import React from 'react';
import PropTypes from 'prop-types';
import ChannelTitle from 'components/atoms/layout/ChannelTitle';
import CallOutSimple from 'components/molecules/CallOutSimple';
import { Grid, Row, Col } from 'react-bootstrap';

const ScoreboardView = (props) => {
    const rules = [];

    for (const rule of props.rules) {
        rules.push(<Row key={rule.name}>
            <ChannelTitle>
                {rule.name}
            </ChannelTitle>
            <Col xs={12} md={3}>
                <CallOutSimple
                    title='Protected Budget'
                    format='$ 0,0.00'
                    data={{
                        value: rule.scoreboard.totalProtectedBudget,
                    }} />
            </Col>
            <Col xs={12} md={3}>
                <CallOutSimple
                    title='Monitor Count'
                    format='0,0'
                    data={{
                        value: rule.scoreboard.monitorTotalCount,
                    }} />
            </Col>
            <Col xs={12} md={3}>
                <CallOutSimple
                    title='Coverage'
                    format='0.00 %'
                    data={{
                        value: rule.scoreboard.activationPercentage,
                    }} />
            </Col>
            <Col xs={12} md={3}>
                <CallOutSimple
                    title='Opportunites'
                    format='0,0'
                    data={{
                        value: rule.scoreboard.uniqueOpportunityTrackablesCount,
                    }} />
            </Col>
            <Col xs={12} md={3}>
                <CallOutSimple
                    title='Failures (last 30 days)'
                    format='0,0'
                    data={{
                        value: rule.scoreboard.totalAlertCount,
                    }} />
            </Col>
            <Col xs={12} md={3}>
                <CallOutSimple
                    title='Total Subscriptions'
                    format='0,0'
                    data={{
                        value: rule.scoreboard.subscriptionCount,
                    }} />
            </Col>
            <Col xs={12} md={3}>
                <CallOutSimple
                    title='Unique Users Subscribed'
                    format='0,0'
                    data={{
                        value: rule.scoreboard.uniqueUserSubscriptionCount,
                    }} />
            </Col>
            <Col xs={12} md={3}>
                <CallOutSimple
                    title='Monitors w/ No Subscriptions'
                    format='0,0'
                    data={{
                        value: rule.scoreboard.monitorsWithNoSubscriptionCount,
                    }} />
            </Col>
        </Row>);
    }

    return (
        <Grid fluid>
            <Row>
                <ChannelTitle>
                    Scoreboard
                </ChannelTitle>
                <Col xs={12} md={3}>
                    <CallOutSimple
                        title='Protected Budget'
                        format='$ 0,0.00'
                        data={{
                            value: props.scoreboard.totalProtectedBudget,
                        }} />
                </Col>
                <Col xs={12} md={3}>
                    <CallOutSimple
                        title='Tracked Opportunities'
                        format='0,0'
                        data={{
                            value: props.scoreboard.uniqueOpportunityTrackablesCount,
                        }} />
                </Col>
                <Col xs={12} md={3}>
                    <CallOutSimple
                        title='Opportunities in CE'
                        format='0,0'
                        data={{
                            value: props.scoreboard.campaignEngineOpportunityTotalCount,
                        }} />
                </Col>
                <Col xs={12} md={3}>
                    <CallOutSimple
                        title='Coverage'
                        format='0.00 %'
                        data={{
                            value: props.scoreboard.activationPercentage,
                        }} />
                </Col>
            </Row>
            {rules}
        </Grid>
    );
};

ScoreboardView.propTypes = {
    rules: PropTypes.array.isRequired,
    scoreboard: PropTypes.object.isRequired,
};

export default ScoreboardView;



// WEBPACK FOOTER //
// ./src/components/organisms/smartguard/ScoreboardView.js